

 // Function to create a cookie
 export const createCookie = (name: string, value: string, days: number) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Convert days to milliseconds
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${name}=${value || ""}${expires}; path=/; domain=.${window.location.hostname};`; // Set the cookie as secure
//console.log('Cookie set:', name);
  
  };
  
  // Function to get a cookie by name
 export const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts?.pop()?.split(';').shift();
  
  };
  
  // Function to delete a cookie by name
 export const deleteCookie = (name: string) => {
    document.cookie = `${name}=; Max-Age=0; path=/; domain=.${window.location.hostname}`; // Set the cookie with a max age of 0 to delete it
  };